import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import Icon1 from './Icon1';
import Icon2 from './Icon2';
import Icon3 from './Icon3';
import styles from './index.module.scss';

export default function SectionCard() {
    const { t } = useLang('theProduct.SectionCard');
    const LIMIT_ITEMS = [
        {
            icon: <Icon1 />,
            title: t('item1_title'),
            desc: t('item1_desc'),
        },
        {
            icon: <Icon2 />,
            title: t('item2_title'),
            desc: t('item2_desc'),
        },
        {
            icon: <Icon3 />,
            title: t('item3_title'),
            desc: t('item3_desc'),
        },
    ];
    return (
        <div className={styles.SectionCard}>
            <EcoSpace />
            <EcoSectionCommon title={t('title')} />
            <EcoSpaceSmall />
            <div className="limits-container">
                {LIMIT_ITEMS.map((item, index) => {
                    return (
                        <div className="limit-item" key={index}>
                            <div className="icon">{item.icon}</div>
                            <div className="content">
                                <h3 className="item-title">{item.title}</h3>
                                <p className="item-desc">{item.desc}</p>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
